// extracted by mini-css-extract-plugin
module.exports = {"modal-summary":"styles-module__modal-summary___1FFO3"};